import { createSlice } from '@reduxjs/toolkit';

const initialStateProto = {
  userId: '',
  eventId: '',
  eventUniqueNo: '',
  seatId: '',
  name: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  email: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  userStreamingUrlId: '1',
  userChatId: '1',
  paymentStatus: 'N',
};

export const eventAsGuestSlice = createSlice({
  name: 'eventAsGuest',
  initialState: {
    ...initialStateProto,
  },
  reducers: {
    updateEmailAndName: (state, action) => {
      const load = action.payload;
      const name = Object.keys(load)[0];

      return { ...state, [name]: load[name] };
    },

    updateEventSeatInfo: (state, action) => {
      const { info } = action.payload;

      return { ...state, ...info };
    },

    clearForm: () => {
      return { ...initialStateProto };
    },

    clearEventId: (state, action) => {
      // const { info } = action.payload;
      return { ...state, eventUniqueNo: '' };
    },
  },
});

export const {
  updateEmailAndName,
  updateEventSeatInfo,
  clearForm,
  clearEventId,
} = eventAsGuestSlice.actions;

export default eventAsGuestSlice.reducer;
